import { useDesignSystem } from 'contexts/design-system'
import ComboBoxEui from './comboBox.eui'
import ComboBoxMui from './comboBox.mui'
import { ComboBoxProps } from './types'

export type { ComboBoxProps } from './types'
export { DEFAULT_DEBOUNCE_DELAY_MS } from './useComboBoxState'

/**
 * Shared single-select combo box. Renders the EUI or MUI presentation based on
 * the host form's design system (`DesignSystemProvider`, default `'eui'`); the
 * public props and behavior are identical across both branches.
 */
export default function ComboBox<T>( props: ComboBoxProps<T> ) {
	return useDesignSystem() === 'mui'
		? <ComboBoxMui {...props} />
		: <ComboBoxEui {...props} />
}
